import { SortItems } from "service/procedureList/types";

type TableFilterMapKeys =
  | "accountManager"
  | "accountSupervisor"
  | "accountTeamLeader"
  | "taskLabelName"
  | "taskId"
  | "highRegulated"
  | "pmpExcluded"
  | "temporaryTask"
  | "procedureStatus"
  | "procedureSaveInCategory"
  | "primaryProcedureOwner"
  | "procedureFolderStatus"
  | "isSharedTask"
  | "procedureOwnerName"
  | "sharedTaskNames"
  | "sharedTaskIds";

type SortItemKey = keyof SortItems;

class TableFilterMap {
  private map: Map<TableFilterMapKeys, SortItemKey>;
  constructor() {
    this.map = new Map();
    this.map.set("accountManager", "amIds");
    this.map.set("accountSupervisor", "asIds");
    this.map.set("accountTeamLeader", "tlIds");
    this.map.set("taskLabelName", "taskLabelNames");
    this.map.set("taskId", "taskIds");
    this.map.set("highRegulated", "isHighlyRegulated");
    this.map.set("pmpExcluded", "isPmpExcluded");
    this.map.set("temporaryTask", "isTemporaryTask");
    this.map.set("procedureStatus", "procedureStatusIds");
    this.map.set("procedureSaveInCategory", "procedureSaveInCategoryIds");
    this.map.set("primaryProcedureOwner", "ppoIds");
    this.map.set("procedureFolderStatus", "procedureFolderStatusIds");
    this.map.set("isSharedTask", "isSharedTask");
    this.map.set("procedureOwnerName", "poIds");
    this.map.set("sharedTaskNames", "taskIds");
    this.map.set("sharedTaskIds", "taskIds");
  }

  set(key: TableFilterMapKeys, value: SortItemKey): void {
    this.map.set(key, value);
  }

  get(key: TableFilterMapKeys): SortItemKey | undefined {
    return this.map.get(key);
  }
}

const tableFilterMap = new TableFilterMap();

export default tableFilterMap;
export type { TableFilterMapKeys };
